import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AppUtils } from 'src/app/helpers/app.utils';
import { TableModel } from 'src/app/models/table.model';
import { PageUrls } from 'src/app/helpers/page-urls';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/admin/services/event.service';
import { PagedEventDetails } from 'src/app/admin/models/paged.event.detail';

@Component({
    selector: 'app-event-table-view',
    templateUrl: './event.table.view.component.html',
    styleUrls: ['./event.table.view.component.scss']
})
export class EventTableViewComponent implements OnInit {
    @Input() tableModel: TableModel;
    @Input() premium: boolean;
    subscriptions = new Array<Subscription>();
    pagedEventDetails = new PagedEventDetails();
    totalRecords = 0;
    isModelLoaded = false;
    isPremium = false;
    selectedAll = false;
    hideDownloadButton = true;
    imageIds: Array<number>;

    get urls() {
        return PageUrls;
    }

    constructor(private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private eventService: EventService,
        private router: Router) {
    }

    ngOnInit() {
        this.initSubscribers();
        this.getEvents();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getEvents());
        this.subscriptions.push(subscription);
    }

    getEvents = () => {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.eventService.list(this.tableModel)
            .subscribe(data => {
                Object.assign(this.pagedEventDetails, data);
                this.totalRecords = data.totalCount;
                this.tableModel.totalPages = data.totalPages;
                this.pagedEventDetails.items.forEach(event => {
                    event.date = AppUtils.getFormattedDate(event.date);
                });
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    selectAll() {
        this.hideDownloadButton = !this.selectedAll;
        this.pagedEventDetails.items.forEach(event => {
            event.isSelected = this.selectedAll;

        });
    }

    updateSelectAll() {
        const selectedEventIdList = this.pagedEventDetails.items.filter(x => x.isSelected);
        this.hideDownloadButton = selectedEventIdList.length === 0;
        if (selectedEventIdList.length !== this.pagedEventDetails.items.length) {
            this.selectedAll = false;
        } else {
            this.selectedAll = true;
        }
    }

    deleteEvent(id: number) {
        if (!confirm('Are you sure you want to delete this event?')) {
            return;
        }
        this.ngxSpinner.show();
        this.eventService.delete(id)
            .subscribe(() => {
                this.toastr.success('Event has been deleted successfully');
                this.ngxSpinner.hide();
                this.getEvents();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openImageCount(id: number) {
        const queryParams = this.tableModel.toQueryParams();
        queryParams['isTableView'] = true;
        this.router.navigate([], { queryParams: queryParams });
        setTimeout(() => {
            this.router.navigateByUrl(`${PageUrls.Admin.EventManageImage}?id=${id}`);
        });
    }

    openEditEvent(id: number) {
        this.router.navigateByUrl(`${PageUrls.Admin.EventEdit}?eventId=${id}&${this.tableModel.toQueryString()}`);
    }

    resetTableModel() {
        this.tableModel.page = 1;
    }

    getImageIds() {
        const selectedEventIdList = this.pagedEventDetails.items.filter(x => x.isSelected === true).map((item) => item.id);
        if (selectedEventIdList.length === 0) {
            this.toastr.error('Please select an event to download');
            return;
        }
        this.ngxSpinner.show();
        this.eventService.imageIds(selectedEventIdList).subscribe(async res => {
            this.imageIds = res;
            setTimeout(() => {
                this.ngxSpinner.hide();
            }, 200);
            for (let i = 0; i < this.imageIds.length; i++) {
                await this.getImageUrl(this.imageIds[i]);
            }
        }, error => {
            this.ngxSpinner.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });

    }

    async getImageUrl(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.eventService.imageUrls(id)
                .subscribe(async image => {
                    await this.downloadImage(image).then(() => {
                        resolve(true);
                    });
                }, error => {
                    reject(false);
                    AppUtils.processErrorResponse(this.toastr, error);
                });
        });
    }

    async downloadImage(image: any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            fetch(image.imageUrl).then(async (img: any) => {
                resolve(true);
                const imageBlog = await img.blob();
                const imageURL = URL.createObjectURL(imageBlog);
                const element = document.createElement('a');
                element.href = imageURL;
                element.download = `${image.fileName}`;
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }).catch(error => {
                reject(false);
            });
        });
    }
}
